import * as React from 'react';

import type { IconProps } from './types';

export const Category = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M268.292 0h-97.28C58.885 0 .005 58.88.005 170.494v97.28c0 111.615 58.88 170.494 170.494 170.494h97.28c111.615 0 170.494-58.88 170.494-170.494v-97.28C438.785 58.879 379.906 0 268.291 0zM853.509 0h-97.282C644.611 0 585.731 58.88 585.731 170.494v97.28c0 111.615 58.88 170.494 170.496 170.494h97.282c111.612 0 170.487-58.88 170.487-170.494v-97.28C1023.996 58.879 965.122 0 853.509 0zM853.509 585.22h-97.282c-111.616 0-170.496 58.88-170.496 170.497v97.274c0 111.621 58.88 170.494 170.496 170.494h97.282c111.612 0 170.487-58.874 170.487-170.494v-97.274c0-111.617-58.874-170.497-170.487-170.497zM268.292 585.22h-97.28C58.885 585.22.005 644.1.005 755.717v97.274C.005 965.118 58.885 1024 170.499 1024h97.28c111.615 0 170.494-58.882 170.494-170.494v-97.282c.512-112.123-58.367-171.003-169.982-171.003z"
        fill={color}
      />
    </svg>
  )
);

export default Category;
